import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const PALETTE = [
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#ff7c7c',
  '#8dd1e1',
  '#a4de6c',
  '#d0aaf3',
  '#ffb347',
  '#87ceeb',
  '#dda0dd',
];

const MarketBarChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={Math.max(300, data.length * 40)}>
      <BarChart data={data} layout="vertical" margin={{ top: 5, right: 30, left: 80, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" allowDecimals={false} />
        <YAxis type="category" dataKey="market" width={100} tick={{ fontSize: 12 }} />
        <Tooltip formatter={(value) => [value, 'Total Tickets']} />
        <Bar dataKey="total" name="Total Tickets">
          {data.map((entry, idx) => (
            <Cell key={`market-bar-${entry.market}`} fill={PALETTE[idx % PALETTE.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

MarketBarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      market: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default MarketBarChart;
